<template>
  <v-btn
    color="primary"
    @click="close"
    prepend-icon="mdi-arrow-left"
    class="ma-2"
    :disabled="loading"
  >
    {{ t('back') }}
  </v-btn>
  <div v-if="loading" class="grid-loading">
    <v-progress-circular indeterminate />
  </div>
  <v-expansion-panels v-else :model-value="0">
    <OrgTable @clikOrg="changeUserClient" />
  </v-expansion-panels>
</template>
<script setup>
import { ref } from 'vue';
import OrgTable from './OrgTable.vue';
import changeClient from '../../helpers/changeClient';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const emit = defineEmits(['close']);
const loading = ref(false);

async function changeUserClient(org) {
  loading.value = true;
  await changeClient(org.orgId);
  loading.value = false;
  close();
}

function close() {
  emit('close');
}
</script>
<i18n>
  {
    "en": {
      "back": "Back",
    },
    "es": {
      "back": "Regresar",
    }
  }
</i18n>

<style scoped>
.grid-loading {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
